module.exports = __webpack_public_path__ + "static/media/uberEats-1.62ace329.png";